/**
 * Which page buttons a pager shows: the first, the last, and the current page
 * with one neighbour either side, with `null` standing for a gap. A catalog of
 * two hundred pages then renders seven buttons, not two hundred.
 *
 *   pageWindow(6, 20)  ->  [1, null, 5, 6, 7, null, 20]
 */
export function pageWindow(page: number, pageCount: number): Array<number | null> {
  const wanted = new Set([1, pageCount, page - 1, page, page + 1]);
  const pages = [...wanted].filter((p) => p >= 1 && p <= pageCount).sort((a, b) => a - b);
  const out: Array<number | null> = [];
  pages.forEach((p, i) => {
    const prev = pages[i - 1];
    if (prev !== undefined && p - prev > 1) out.push(null);
    out.push(p);
  });
  return out;
}
